!function($) {

  $(function() {
		
		/**********************************************************************************
		General
		- animations
		- anchored header
		**********************************************************************************/
		
		/* animations
		--------------------------------------------- */
		AOS.init({
			//disable: "mobile",
			duration: 1000,
			once: true,
			mirror: false
		});
		
		/* anchored header
		--------------------------------------------- */
		$(window).scroll(function() {
			if ($(window).scrollTop() > ($('#shopify-section-header').outerHeight() + 100)) {
				$('#shopify-section-header').addClass('anchor');
			} else {
				$('#shopify-section-header').removeClass('anchor');
			}
		});
		
		$(window).on("load resize", function() {
			$('#app-body').css('padding-top', $('#shopify-section-header').outerHeight() + 'px');
		}).resize();

		/**********************************************************************************
		Navigation
		- keyboard focus
		**********************************************************************************/
		
		/* focus for keyboards
		--------------------------------------------- */
		$('nav li a').focus(function() {
			$(this).siblings('nav li ul').addClass('focused');
		}).blur(function() {
			$(this).siblings('nav li ul').removeClass('focused');
		});
		$('nav li a').focus(function() {
			$(this).parents('nav li ul').addClass('focused');
		}).blur(function() {
			$(this).parents('nav li ul').removeClass('focused');
		});
		
		/**********************************************************************************
		Pages
		- home
		- shop
		**********************************************************************************/
		
		/* home
		--------------------------------------------- */
		// rich text
		$('#shopify-section-template--14193871618097__1649095440d024f5f8 .section-block-header-heading').html(function() {
			$(this).html($(this).html().replace(/Culinary/ig,'<em class="script">Culinary</em>'));
		});
		
		
		// image with text
		$('#shopify-section-template--14193871618097__image-with-text-1 .image-with-text-section-inner-text-heading').html(function() {
			$(this).html($(this).html().replace(/Fruit Caramels/ig,'<em class="script">Fruit Caramels</em>'));
		});
		
		/*$('#shopify-section-template--14193871618097__image-with-text-1 .image-with-text-section-inner-text-heading').html(function(){	
			var text = $(this).text().split(' ');
			var last = text.pop();
			return text.join(" ") + (text.length > 0 ? ' <span class="last">'+last+'</span>' : last);
		});*/
		
		/* about
		--------------------------------------------- */
		$('html[class*="founder"] h1.title').html(function() {
			$(this).html($(this).html().replace(/and Chief Caramel Creator/ig,'<em class="script">and Chief Caramel Creator</em>'));
		});
		
		$('html[class*="founder"] h2').html(function() {
			$(this).html($(this).html().replace('<em>','<em class="script">'));
		});
		
		/* process
		--------------------------------------------- */
		$('html[class*="process"] h1.title').html(function() {
			$(this).html($(this).html().replace(/coveted fruit caramels/ig,'<em class="script">Coveted Fruit Caramels</em>'));
		});
		
		$('html[class*="process"] main > p:first-of-type').html(function() {
			$(this).html($(this).html().replace('<em>','<em class="script">'));
		});
		
		/* sampler pack
		--------------------------------------------- */
		$('html[class*="sampler"] h1.title').html(function() {
			$(this).html($(this).html().replace(/Favorite Flavor/ig,'<em class="script">Favorite Flavor</em>'));
		});
		
		
		/* shop
		--------------------------------------------- */
		// product: quantity
		$('[data-quantity="plus"]').click(function(e){
			e.preventDefault();
			fieldName = $(this).attr('data-field');
			var currentVal = parseInt($('input[name='+fieldName+']').val());
			if (!isNaN(currentVal)) {
				$('input[name='+fieldName+']').val(currentVal + 1);
			} else {
				$('input[name='+fieldName+']').val(0);
			}
		});
		
		$('[data-quantity="minus"]').click(function(e) {
			e.preventDefault();
			fieldName = $(this).attr('data-field');
			var currentVal = parseInt($('input[name='+fieldName+']').val());
			if (!isNaN(currentVal) && currentVal > 0) {
				$('input[name='+fieldName+']').val(currentVal - 1);
			} else {
				$('input[name='+fieldName+']').val(0);
			}
		});
		
		// cart: agree to terms
		$('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms of service to check out.");
        return false;
      }
    });
	
  });

}(jQuery);